import { clientId, clientSecret } from './urls'

// Configuration object for axios
const config = {
    headers: {
        'Access-Control-Allow-Origin': '*',
        'Content-Type': 'application/json'
    }
}

// Utility function to remove special characters from a string
const sanitizeString = str => {
    return str
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/[^a-zA-Z0-9 ]/g, '')
}

// Function to get the configuration object with the user's email and sanitized display name
export const getConfigWithUserEmail = currentUser => {
    return {
        ...config,
        headers: {
            ...config.headers,
            'User-Email': currentUser.email, // Add the user's email to the headers
            'User-Name': sanitizeString(currentUser.displayName), // Add the sanitized user's display name to the headers
            'User-uid': currentUser.uid // Add the user's UID to the headers
        }
    }
}

// Create basic auth configuration
export const basicAuthConfig = user => {
    return {
        ...config,
        headers: {
            ...config.headers,
            Authorization: 'Basic ' + btoa(clientId + ':' + clientSecret), // Replace with your actual username and password
            'User-Email': user.email, // Add the user's email to the headers
            'User-Name': sanitizeString(user.displayName), // Add the sanitized user's display name to the headers
            'User-uid': user.uid // Add the user's UID to the headers
        }
    }
}
